// extracted by mini-css-extract-plugin
export default {"cell":"jvMP4f2IzPouW5sG0zzb","lastRow":"a7PulBb96ZgikBZqDDuD","lastColumn":"MGG3JbIQQLkNasPh6EWg"};